import { Presentation, ImageWithMetadata } from '@features/powerpoint';
import { Campaign } from '@features/campaigns';
import { DEFAULT_FILENAME } from '@features/executive-report/utils';
import { createSharedPresentationConfig as createSharedPresentationConfigV1 } from '@features/executive-report/utils/shared-presentation-config';
import { FormSchema as FormSchemaV1 } from '../form-schema';
import { CampaignOverviewSlideOptions } from '../slides/campaign-overview/campaign-overview';
import { SubdimensionCounts } from '@features/reports';
import { salesDimensionsSlides } from '../slides/sales-dimensions/sales-dimensions';
import { buildSlideMasters } from '@features/executive-report/utils/slide-masters';
import { buildSlidesV2 } from './build-slides-v2';
import { buildSlidesV1 } from './build-slides-v1';
import { createSharedPresentationConfigV2 } from '@features/executive-report/utils/shared-presentation-config-v2';
import { FormSchema as FormSchemaV2 } from '../domain/v2/form-schema';

export type BuildReportOptions = {
  brandLogo: ImageWithMetadata | null;
  campaign: Pick<Campaign, 'id' | 'name' | 'startDate' | 'endDate' | 'adSpend'>;
  report: CampaignOverviewSlideOptions['report'];
  retailerCount: number;
  subdimensionCounts: SubdimensionCounts;
  roasData: {
    iroas: number | null;
    roas: number | null;
  };
  topSalesSubdimensionsByName: Parameters<
    typeof salesDimensionsSlides
  >[0]['subdimensionsByName'];
  topRetailers: Parameters<typeof salesDimensionsSlides>[0]['topRetailers'];
} & (
  | { designVersion: 'v1'; customFields: FormSchemaV1 }
  | { designVersion: 'v2'; customFields: FormSchemaV2 }
);

export const buildPresentation = (
  options: BuildReportOptions
): Presentation => {
  const { slides, createSharedPresentationConfig } = (() => {
    if (options.designVersion === 'v1') {
      return {
        slides: buildSlidesV1(options),
        createSharedPresentationConfig: createSharedPresentationConfigV1,
      };
    }

    return {
      slides: buildSlidesV2(options),
      createSharedPresentationConfig: (
        brandLogo: BuildReportOptions['brandLogo']
      ) => createSharedPresentationConfigV2(buildSlideMasters(brandLogo)),
    };
  })();

  return {
    ...createSharedPresentationConfig(options.brandLogo),
    filename: [options.campaign.name, DEFAULT_FILENAME].join(' - '),
    slides,
  };
};
